import {
  CAPTCHA_COMPLETE,
  CAPTCHA_EXPIRE,
  EXPIRE_SESSION_TOKEN,
  RECEIVE_SESSION_TOKEN,
  SET_EMAIL,
  SET_EMAIL2,
  SET_FIRST_NAME,
  SET_LAST_NAME,
  SET_PHONE,
  TOGGLE_GTI_Receipt,
  SET_CUSNUMBER,
  SET_PROVINCIA,
  SET_PROVINCIA_ID,
  SET_CANTONS,
  SET_CANTON_ID,
  SET_DISTRITOS,
  SET_DISTRITO_ID,
  SET_BARRIOS,
  SET_BARRIO_ID,
  SET_DIRECCION,
  SET_TIPO_IDENT,
  SET_TIPO_DOC,
  SET_AREA_TELEFONO,
  SET_NUM_TELEFONO,
  SET_CORREO,
  SET_FULL_NAME,
  RESET_GTI,
  SET_PROMO,
  REMOVE_PROMO_TEXT,
  RECEIVE_CHECKOUT_INFO,
  SET_ACCEPT_TERMS,
  SET_HAS_YOUNG_CHILDREN,
  SET_CUSTOMER_CARD_NUMBER,
  SET_USED_LOCAL_STORAGE
} from '../actions/checkout';
import { RESET_APP, RESET_CART } from '../actions/index';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  email2: '',
  phone: '',

  GTIReceipt: false,
  cusNumber: '',
  provinciaId: '',
  provincia: '',
  cantonId: '',
  distritoId: '',
  barrioId: '',
  direccion: '',
  tipoIdent: '1',
  tipoDoc: "4",
  areaTelefono: '',
  numTelefono: '',
  correo: '',
  fullName: '',

  promo: '',
  captchaResponse: '',
  sessionToken: '',
  purchaseCode: '',
  signedAuthorizationRequest: undefined,
  giftCardEnabled: false,
  hasAcceptedTerms: false,
  hasYoungChildren: false,
  customerCardNumber: "",
  usedLocalStorage: false
};

const CheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAPTCHA_COMPLETE:
      return { ...state, captchaResponse: action.response };
    case CAPTCHA_EXPIRE:
      return { ...state, captchaResponse: '' };
    case RECEIVE_SESSION_TOKEN:
      return { ...state, sessionToken: action.sessionToken, purchaseCode: action.purchaseCode, signedAuthorizationRequest: action.signedAuthorizationRequest };
    case EXPIRE_SESSION_TOKEN:
      return { ...state, sessionToken: '', purchaseCode: '', captchaResponse: '' };
    case RESET_CART:
    case RESET_APP:
      // do not reset checkout information data
      return {
        ...initialState
      };
    case SET_EMAIL:
      return { ...state, email: action.email };
    case SET_EMAIL2:
      return { ...state, email2: action.email2 };
    case SET_FIRST_NAME:
      return { ...state, firstName: action.firstName };
    case SET_LAST_NAME:
      return { ...state, lastName: action.lastName };
    case SET_PHONE:
      return { ...state, phone: action.phone };
    
    // COSTA RICA ITEMS
    case TOGGLE_GTI_Receipt:
      return { ...state, GTIReceipt: action.GTIReceipt }
    case SET_CUSNUMBER:
      return { ...state, cusNumber: action.cusNumber};
    case SET_PROVINCIA_ID:
      return { 
        ...state, 
        provinciaId: action.provinciaId,
        cantonId: '',
        distritoId: '',
        barrioId: ''
      };
    case SET_CANTON_ID:
      return { 
        ...state, 
        cantonId: action.cantonId,
        distritoId: '',
        barrioId: ''
      };
    case SET_DISTRITO_ID:
      return { 
        ...state, 
        distritoId: action.distritoId,
        barrioId: ''
      };
    case SET_BARRIO_ID:
      return { ...state, barrioId: action.barrioId};
    case SET_DIRECCION:
      return { ...state, direccion: action.direccion};
    case SET_TIPO_IDENT:
      return { ...state, tipoIdent: action.tipoIdent};
    case SET_TIPO_DOC:
      return { ...state, tipoDoc: action.tipoDoc};
    case SET_AREA_TELEFONO:
      return { ...state, areaTelefono: action.areaTelefono};
    case SET_NUM_TELEFONO:
      return { ...state, numTelefono: action.numTelefono};
    case SET_CORREO:
      return { ...state, correo: action.correo};
    case SET_FULL_NAME:
      return { ...state, fullName: action.fullName};
    case RESET_GTI:
      // do not reset checkout information data
      return {
        ...state,
        cusNumber: '',
        provinciaId: '',
        cantonId: '',
        distritoId: '',
        barrioId: '',
        direccion: '',
        tipoIdent: '',
        tipoDoc: '',
        areaTelefono: '',
        numTelefono: '',
        correo: '',
        fullName: '',
      };
    case SET_PROVINCIA:
      return { 
        ...state, 
        provincia: action.provincia,
        cantons: '',
        distritos: '',
        barrios: ''
      };
    case SET_CANTONS:
      return { 
        ...state, 
        cantons: action.cantons,
        distritos: '',
        barrios: '' 
      };
    case SET_DISTRITOS:
      return {
        ...state, 
        distritos: action.distritos,
        barrios: ''  
      };
    case SET_BARRIOS:
      return { ...state, barrios: action.barrios };

    case SET_PROMO:
      return { ...state, promo: action.promo };
    case SET_ACCEPT_TERMS:
      return {...state, hasAcceptedTerms: action.hasAcceptedTerms };
    case SET_HAS_YOUNG_CHILDREN:
      return {...state, hasYoungChildren: action.hasYoungChildren };
    case REMOVE_PROMO_TEXT:
      return { ...state, promo: '' };
    case RECEIVE_CHECKOUT_INFO:
      return { ...state, giftCardEnabled: action.giftCardEnabled };
    case SET_CUSTOMER_CARD_NUMBER:
      return {...state, customerCardNumber: action.customerCardNumber };
    case SET_USED_LOCAL_STORAGE:
      return {...state, usedLocalStorage: action.usedLocalStorage };
    default:
      return state;
  }

};

export default CheckoutReducer;
